<script>
import {Calendar} from '@fullcalendar/core'
import nlLocale from '@fullcalendar/core/locales/nl';

import timeGridPlugin from '@fullcalendar/timegrid'
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import InfoModal from "@/pages/appointments/partials/info-modal.vue";

export default {
  components: {InfoModal, Card, App},
  props: ['userId'],
  data() {
    return {
      show: {}
    }
  },
  mounted() {
    this.initialiseCalendar();
  },
  methods: {
    initialiseCalendar() {
      let calendar = new Calendar(this.$refs.calendar, {
        plugins: [timeGridPlugin, bootstrap5Plugin],
        initialView: 'timeGridWeek',
        themeSystem: 'bootstrap5',
        locale: nlLocale,
        events: route('api.v1.appointments.events', {user_id: this.userId}),
        allDaySlot: false,
        eventClick: this.onEventClick.bind(this)
      });

      calendar.render();

      $(this.$refs.calendar).data('calendar', calendar);
    },

    onEventClick(info) {
      this.show = {
        id: info.event._def.publicId,
        name: info.event._def.title,
        products: info.event._def.extendedProps.products,
        start_date: info.event._instance.range.start,
        end_date: info.event._instance.range.end,
        description: info.event._def.extendedProps.description,
        customer: {
          full_address: info.event._def.extendedProps.full_address,
          phone: info.event._def.extendedProps.phone,
          phone_number_formatted: info.event._def.extendedProps.phone_formatted,
          mobile: info.event._def.extendedProps.mobile,
          mobile_number_formatted: info.event._def.extendedProps.mobile_formatted,
        },
      };

      this.$refs.modal.open();
    }
  }
}
</script>

<template>
  <App title="Agenda">
    <Card>
      <div style="min-height:500px" ref="calendar"></div>
    </Card>

    <InfoModal :appointment="show" ref="modal"/>
  </App>
</template>